import { render, staticRenderFns } from "./shalbon-bihar.vue?vue&type=template&id=15db5505&scoped=true&"
import script from "./shalbon-bihar.vue?vue&type=script&lang=js&"
export * from "./shalbon-bihar.vue?vue&type=script&lang=js&"
import style0 from "./shalbon-bihar.vue?vue&type=style&index=0&id=15db5505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db5505",
  null
  
)

export default component.exports